function Category(props) {
  return <h1>Category</h1>;
}

export default Category;
